import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import CountUp from "react-countup";
import "./SeedInput.css";
import Footer from "../Home/Footer";
import GetInTouchImage from "../assets/img/GetInTouchSeedPage.jpg";
import Slider1 from "../assets/img/SeedSlider-1.jpg";
import Slider2 from "../assets/img/SeedSlider-2.jpg";
import Slider3 from "../assets/img/SeedSlider-3.jpg";
import FaqImage from "../assets/img/FAQSeedPage.jpg";

const SeedsInputs = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const carouselData = [
    {
      image: Slider1,
      title: "Premium Seeds for Maximum Yield",
      description: "Boost your farm’s productivity with high-quality seeds.",
    },
    {
      image: Slider2,
      title: "Quality Inputs for Better Growth",
      description: "Get the best fertilizers and nutrients for your crops.",
    },
    {
      image: Slider3,
      title: "Advanced Agricultural Solutions",
      description: "Innovative solutions for modern-day farming.",
    },
  ];

  const faqs = [
    {
      question: "What are the best seeds for my farm?",
      answer:
        "We offer a variety of seeds suited for different climates and soil conditions.",
    },
    {
      question: "Do you offer organic fertilizers?",
      answer: "Yes, we provide organic fertilizers for sustainable farming.",
    },
    {
      question: "How can I improve my farm’s productivity?",
      answer:
        "Using our high-quality seeds and trusted agricultural inputs can help.",
    },
  ];

  return (
    // <div className="seeds-page">
    //   {/* 🔹 Hero Section (Carousel) */}
    //   <section className="carousel-section">
    //     <Swiper
    //       modules={[Pagination, Navigation, Autoplay]}
    //       pagination={{ clickable: true }}
    //       navigation={true}
    //       autoplay={{ delay: 3000, disableOnInteraction: false }}
    //       loop={true}
    //       className="custom-swiper"
    //     >
    //       {carouselData.map((slide, index) => (
    //         <SwiperSlide key={index}>
    //           <div
    //             className="carousel-item"
    //             style={{ backgroundImage: `url('${slide.image}')` }}
    //           >
    //             <div className="overlay">
    //               <h2 style={{ color: "#d4561a" }}>{slide.title}</h2>
    //               <p>{slide.description}</p>
    //             </div>
    //           </div>
    //         </SwiperSlide>
    //       ))}
    //     </Swiper>
    //   </section>

    //   {/* 🔹 About & Statistics */}
    //   {/* <section className="about-section" data-aos="fade-up">
    //     <div className="container-about">
    //       <h2>🌱 About Our Seeds & Inputs</h2>
    //       <p>
    //         We provide the best agricultural inputs to help farmers achieve
    //         better yields.
    //       </p>

    //       <div className="stats-row">
    //         <div className="stat-box animated-card" data-aos="fade-up">
    //           <h3>
    //             <CountUp end={5000} duration={3} />+
    //           </h3>
    //           <p>Farmers Served</p>
    //         </div>
    //         <div className="stat-box animated-card" data-aos="fade-up">
    //           <h3>
    //             <CountUp end={200} duration={3} />+
    //           </h3>
    //           <p>Seed Varieties</p>
    //         </div>
    //         <div className="stat-box animated-card" data-aos="fade-up">
    //           <h3>
    //             <CountUp end={50} duration={3} />+
    //           </h3>
    //           <p>Years of Experience</p>
    //         </div>
    //       </div>
    //     </div>
    //   </section> */}

    //   {/* 🔹 FAQ Section */}
    //   {/* <section className="faq-container" data-aos="fade-up">
    //     <div className="container">
    //       <div className="faq-row align-items-center">
    //         Left Column - FAQ Content
    //         <div className="col-md-6" data-aos="fade-left">
    //           <h2>
    //             Frequently Asked <span className="highlight">Questions</span>
    //           </h2>
    //           <p>Find answers to common questions about our products.</p>

    //           <div className="accordion" id="faqAccordion">
    //             {faqs.map((faq, index) => (
    //               <div
    //                 className="accordion-item"
    //                 key={index}
    //                 data-aos="fade-up"
    //               >
    //                 <h2 className="accordion-header">
    //                   <button
    //                     className={`accordion-button ${
    //                       index !== 0 ? "collapsed" : ""
    //                     }`}
    //                     type="button"
    //                     data-bs-toggle="collapse"
    //                     data-bs-target={`#faq${index}`}
    //                   >
    //                     {faq.question}
    //                   </button>
    //                 </h2>
    //                 <div
    //                   id={`faq${index}`}
    //                   className={`accordion-collapse collapse ${
    //                     index === 0 ? "show" : ""
    //                   }`}
    //                   data-bs-parent="#faqAccordion"
    //                 >
    //                   <div className="accordion-body">{faq.answer}</div>
    //                 </div>
    //               </div>
    //             ))}
    //           </div>
    //         </div>

    //         Right Column - FAQ Image
    //         <div
    //           className="col-md-6 text-center position-relative"
    //           data-aos="fade-right"
    //         >
    //           <img src={FaqImage} alt="FAQ" className="faq-image img-fluid" />
    //           <h2 className="faq-text">FAQ</h2>
    //         </div>
    //       </div>
    //     </div>
    //   </section> */}

    //   {/* 🔹 Contact Section */}
    //   {/* <section
    //     className="contact-section"
    //     data-aos="fade-up"
    //     style={{
    //       background: `url(${GetInTouchImage}) no-repeat center center/cover`,
    //     }}
    //   >
    //     <div className="container text-center">
    //       <h2 className="fw-bold" style={{ color: "#d4561a" }}>
    //         Get in Touch
    //       </h2>
    //       <p>Want to know more? Contact us today!</p>
    //       <Link to="/contact-us" className="btn btn-primary">
    //         Contact Us
    //       </Link>
    //     </div>
    //   </section> */}

    //   <Footer />
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeedsInputs;
